import { inject, Injectable } from '@angular/core';
import { BulkReviewRow } from '@ps/survey-utils';

import { BulkReviewPanelStateRegistry } from './bulk-review-panel-state.registry';

@Injectable({ providedIn: 'root' })
export class BulkEditPanelStateManager {
  private readonly _registry = inject(BulkReviewPanelStateRegistry);

  public records(): BulkReviewRow[] {
    return this._registry.currentState()?.records() ?? [];
  }

  public startOperation(): void {
    this._registry.currentState()?.setOperationInProgress(true);
  }

  public finishOperation(): void {
    this._registry.currentState()?.setOperationInProgress(false);
  }

  public complete(): void {
    this._registry.currentState()?.complete();
  }

  public updateDefaultErrorInRecord(surveyId: number, message: string): void {
    this._registry
      .currentState()
      ?.updateRecord(
        { field: 'id', value: surveyId },
        { error: { type: 'default', context: 'api', message } },
      );
  }

  public updateApprovableErrorInRecord(
    surveyId: number,
    message: string,
  ): void {
    this._registry.currentState()?.updateRecord(
      { field: 'id', value: surveyId },
      {
        error: {
          type: 'approvable',
          context: 'api',
          message,
          approved: false,
        },
      },
    );
  }

  public updateDefaultErrorInRecords(message: string): void {
    this._registry.currentState()?.updateRecords({
      error: { type: 'default', context: 'api', message },
    });
  }

  public deleteRecord(surveyId: number): void {
    this._registry
      .currentState()
      ?.deleteRecord({ field: 'id', value: surveyId });
  }
}
